<template>
	<div>
		<el-card>
			<div slot="header" class="clearfix">
				<el-button @click="dialogFormVisible=true" type="primary">添加角色</el-button>
			</div>
			<div>
				<el-table :data="roleList" style="width:100%;">
					<el-table-column prop="group_id" label="Id">
					</el-table-column>
					<el-table-column prop="name" label="角色名">
					</el-table-column>
					<el-table-column prop="create_time" :formatter="$f.timeFormat" label="创建时间">
					</el-table-column>
					<el-table-column prop="" label="操作">
						<template slot-scope="scope">
							<el-button @click="getUserRule(scope.row.group_id)">编辑</el-button>
							<el-popconfirm style="margin-left: 5px;" confirmButtonText='确定' cancelButtonText='取消' @confirm="roleDel(scope.row.group_id,scope.$index)"
							 icon="el-icon-info" iconColor="red" title="确定删除？">
								<el-button slot="reference" type="danger">删除</el-button>
							</el-popconfirm>
						</template>
					</el-table-column>
					<el-table-column prop="" label="" width="180">
					</el-table-column>
				</el-table>
			</div>
		</el-card>
		<!-- 添加角色弹窗 -->
		<el-dialog title="添加角色" :visible.sync="dialogFormVisible">
			<el-form :model="form" ref="form">
				<el-form-item label="角色名称">
					<el-input v-model="form.name" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" :loading="btnLoading" :disabled="btnDisabled" @click="roleAdd">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 编辑角色弹窗 -->
		<el-dialog title="编辑权限" :visible.sync="showEditDialog" width="80%">
			<el-tree ref="ruleTree" :check-strictly="true" :data="rulelList" @check-change="handleCheckChange"
			 :default-expand-all="true" :props="treePros" show-checkbox node-key="id"></el-tree>
			<div slot="footer" class="dialog-footer">
				<el-button @click="showEditDialog = false">取 消</el-button>
				<el-button type="primary" :loading="btnLoading" :disabled="btnDisabled" @click="roleRuleSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				btnLoading: false,
				btnDisabled: false,
				form: {
					name: ""
				},
				treePros: {
					label: "name"
				},
				showEditDialog: false,
				dialogFormVisible: false,
				roleList: [],
				rulelList: [],
				userRuleIds: [],
				roleId: ""
			}
		},
		created() {
			this.getRoleList();
		},
		methods: {
			handleCheckChange() {
				let Keys = this.$refs.ruleTree.getCheckedKeys()
				let halfKeys = this.$refs.ruleTree.getHalfCheckedKeys() //半选状态
				let arr = []

				let allKeys = Keys.concat(halfKeys)

				this.userRuleIds = allKeys;
			},
			// 获取角色列表
			getRoleList() {
				this.$H.get("user/roleList").then(res => {
					this.roleList = res.result;
				})
			},
			roleAdd() {
				if (!this.form.name) {
					this.$message.error('角色名不能为空');
					return;
				}

				this.btnLoading = true;
				this.btnDisabled = true;
				this.$H.post("user/roleAdd", this.form).then(res => {
					if (res.code === 200) {
						this.$refs.form.resetFields();
						this.$message.success(res.msg)
						this.dialogFormVisible = false;

						this.getRoleList();
					}

					this.btnLoading = false;
					this.btnDisabled = false;
				})
			},
			roleDel(id, index) {
				this.$H.post("user/roleDel", {
					id: id
				}).then(res => {
					if (res.code == 200) {
						this.roleList.splice(index, 1);
						this.$message.success('删除成功');
					}
				})
			},
			getUserRule(id) {
				this.roleId = id;
				this.$H.get("user/roleRuleList", {
					id: id
				}).then(res => {
					this.rulelList = res.result.all_rule;
					this.userRuleIds = res.result.user_rule_ids;

					this.$nextTick(() => {
						this.$refs.ruleTree.setCheckedKeys(res.result.user_rule_ids);
					})
				})
				this.showEditDialog = true;
			},
			roleRuleSave() {
				this.$H.post("user/userRuleSave", {
					role_id: this.roleId,
					rule_ids: this.userRuleIds
				}).then(res => {
					if (res.code == 200) {
						this.$message.success("保存成功");
						this.showEditDialog = false;
					}
				})
			}
		}
	}
</script>

<style>
	/* 自定义权限树形样式 */
.el-tree > .el-tree-node{
	margin-bottom: 10px;
	background-color: #F5F5F5;
}

.el-tree > .el-tree-node > .el-tree-node__children > .el-tree-node > .el-tree-node__children{
	margin-bottom: 10px;
}
.el-tree > .el-tree-node > .el-tree-node__children > .el-tree-node > .el-tree-node__children > .el-tree-node > .el-tree-node__children{
	display: flex;
	margin-bottom: 10px;
}


</style>
